// extracted by mini-css-extract-plugin
module.exports = {"titulo":"styles_titulo__7WBU9"};